import config from '../envConfig';
import crypto from 'crypto';
import jwt from 'jsonwebtoken';
import env from '../envConfig';
import { getHeader } from './authManager';
import http from '../common/http';

declare const cordova: any;

const PERSISTENT_STORE_KEYS = ['cadunico/splash-visualizado', 'cadunico/aviso-carteira-documentos-nao-exibir'];

class Auth {

 delay(t: number) {
    return new Promise(resolve => setTimeout(resolve, t));
  }

  showLoading(message = 'Carregando...') {
    const loadingDiv = document.createElement('div');
    loadingDiv.id = 'auth-loading';
    loadingDiv.innerHTML = `
      <div style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center; z-index: 9999;">
        <div style="background: white; padding: 20px; border-radius: 8px; text-align: center;">
          <div style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 30px; height: 30px; animation: spin 1s linear infinite; margin: 0 auto 10px;"></div>
          <p>${message}</p>
        </div>
      </div>
      <style>
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
    document.body.appendChild(loadingDiv);
  }

  hideLoading() {
    const loadingDiv = document.getElementById('auth-loading');
    if (loadingDiv) {
      loadingDiv.remove();
    }
  }


  private janelaLogin: any = null;

  base64URLEncode(str) {
    return str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
  }

  createCodeVerifier() {
    const rand = crypto.randomBytes(32);
    return this.base64URLEncode(rand);
  }

  sha256(buffer) {
    return crypto.createHash('sha256').update(buffer).digest();
  }

  createCodeChallenge(codeVerifier) {
    return this.base64URLEncode(this.sha256(codeVerifier));
  }

  setPerfilSelecionado(perfil) {
    localStorage.setItem('perfilSelecionado', JSON.stringify(perfil));
  }

  setFamiliaSelecionada(numeroFamiliar) {
    localStorage.setItem('familiaSelecionada', numeroFamiliar);
  }

  setTipoPerfilSelecionado(tipoPerfil) {
    localStorage.setItem('tipoPerfilSelecionado', tipoPerfil);
  }

  login() {
    // Limpar estado OAuth anterior para evitar authorization_request_not_found
    this.limparEstadoOAuth();

    if (config.isCordova) {
      this.loginCordova();
    } else {
      window.location.href = `${config.gateway.loginUrl}`;
    }
  }

  loginCordova() {
    let autenticacaoRetornouSucesso: boolean;
    if (localStorage.getItem('autenticando') !== 'true' && !this.janelaLogin) {

      localStorage.setItem('autenticando', 'true');
      localStorage.setItem('perfilSelecionado', '');

      autenticacaoRetornouSucesso = false;

      let url = `${config.gateway.loginUrl}`;
      this.janelaLogin = cordova.InAppBrowser.open(url, '_blank', 'clearcache=yes,clearsessioncache=yes,toolbar=no,location=no,closebuttoncaption=Fechar,toolbarposition=top,footer=yes,enableViewportScale=yes,footercolor=#071D41');
      this.janelaLogin.addEventListener('loaderror', (params) => {
        this.janelaLogin.close();
        alert(`Falha carregando login:\n${params.message}`);
      });

      // Função para processar sucesso
      const processarSucesso = async (url: string) => {
        if (!autenticacaoRetornouSucesso) {
          try {
            const token = this.extractTokenFromUrl(url);
            autenticacaoRetornouSucesso = true;
            this.janelaLogin.close();
            this.janelaLogin = null;
            await this.delay(500);
            window.location.href = `#/successLogin?token=${token}`;
          } catch (error) {
            console.error('Erro ao processar retorno de autenticação:', error);
            localStorage.setItem('isLoggedInClosed', 'true');
            localStorage.removeItem('autenticando');
            this.janelaLogin.close();
            this.janelaLogin = null;
            window.location.href = '#/';
          }
        }
      };

      this.janelaLogin.addEventListener('loadstart', async (event: any, callback) => {
          if (event.url.includes('successLogin')) {
          // não carregar a url do token
          await processarSucesso(event.url);
        } else {
          // permitir carregamento
          callback(event.url);
        }
        });

      this.janelaLogin.addEventListener('beforeload', (params, callback) => {
        if (params.url.includes('successLogin')) {
          // não carregar a url do token
          processarSucesso(params.url);
        } else {
          // permitir carregamento
          callback(params.url);
        }
      });

      this.janelaLogin.addEventListener('exit', () => {
        if (!autenticacaoRetornouSucesso) {
          localStorage.setItem('isLoggedInClosed', 'true');
        }
        localStorage.removeItem('autenticando');
        this.janelaLogin = null;
      });
    }
  }

  extractTokenFromUrlHash(hash: string) {
    // Normalize: remove leading "#"
    const cleanHash = hash.startsWith("#") ? hash.slice(1) : hash;

    // Hash format example: "/successLogin?token=XYZ"
    const [, queryString] = cleanHash.split("?");


    if (!queryString) {
      throw new Error(`No query string found in url: ${hash}`);
    }

    const params = new URLSearchParams(queryString);
    const token = params.get("token");
    if (!token) {
      throw new Error(`No token found in url: ${hash}`);
    }

    return token;
  }

  extractTokenFromUrl(url: string) {
    const parsed = new URL(url);
    return this.extractTokenFromUrlHash(parsed.hash);
  }

  async onLoginSuccess(token: string) {
    localStorage.setItem("token", token);

    if (token) {
      let tentativas = 0;
      const maxTentativas = 4;

      while (tentativas < maxTentativas) {
        try {
          let response = await this.obterInformacaoUsuarioLogado();

          if (response?.data) {
            localStorage.setItem('user', response.data);
            return; // Sucesso, sair do loop
          } else {
            throw new Error('Response data está vazio ou nulo');
          }
        } catch (err) {
          tentativas++;
          console.error(`Tentativa ${tentativas} falhou ao obter informação do usuário:`, err);

          if (tentativas >= maxTentativas) {
            console.error('Todas as tentativas falharam ao obter informação do usuário logado.');
            throw new Error('Erro obtendo informação do usuário logado após 4 tentativas.', { cause: err });
          }

          // Aguardar antes da próxima tentativa
          await new Promise(resolve => setTimeout(resolve, 400 * tentativas));
        }
      }
    } else {
      console.error('Falha ao obter token.');
      throw new Error('Falha ao obter token.');
    }
  }

  obterInformacaoUsuarioLogado= async () => {
    let url = env.urlApi + `/transacional-api/v1/suporte/configuracao/token`;
    const headers = getHeader();

    const response = await http.get(url, { headers });
    return response ;
  };

  isAuthenticated() {
    const token = localStorage.getItem('token');
    return token !== null && token.trim() !== '';
  }

  isAuthenticatedClose() {
    return localStorage.getItem('isLoggedInClosed') === 'true';
  }

  getToken() {
    return localStorage.getItem('token');
  }

  logout() {
    this.limparStorage();
  }

  logoutGovBr() {
    this.limparStorage();
    if (config.isCordova) {
      const logoutBrowser = cordova.InAppBrowser.open(config.gateway.logoutUrl, '_blank', 'beforeload=yes,clearcache=yes,clearsessioncache=yes,toolbar=no,location=no,closebuttoncaption=Fechar,toolbarposition=top,footer=yes,enableViewportScale=yes,footercolor=#071D41');

      logoutBrowser.addEventListener('beforeload', (params, callback) => {
        // permitir carregar urls de logout:
        // https://cadunico.dataprev.gov.br/transacional/api/logout
        // https://sso.staging.acesso.gov.br/logout
        if (params.url.includes('/logout')) {
          // permitir carregamento
          callback(params.url);
        } else {
          // encerrar logout
          logoutBrowser.close();
          window.location.href = `#/home`;
          alert('FIM LOGOUT!');
        }
      });

      logoutBrowser.addEventListener('loaderror', () => {
        logoutBrowser.close();
      });

    } else {
      window.location.href = `${config.gateway.logoutUrl}`;
    }
  }

  getUser() {
    const user = localStorage.getItem('user');
    if (user) {
      return user.split('@')[0];
    }
    return null;
  }

  getIdToken() {
    return sessionStorage.getItem('id_token');
  }

  getDecodedToken() {
    return jwt.decode(sessionStorage.getItem('id_token'), {
      complete: true,
    });
  }

  getPhoneNumberVerified(): boolean {
    return this.getDecodedToken()?.payload?.phone_number_verified === 'true';
  }
  getEmailVerified(): boolean {
    return this.getDecodedToken()?.payload?.email_verified === 'true';
  }
  getPhoneNumber(): string {
    return this.getDecodedToken()?.payload?.phone_number;
  }
  getEmail(): string {
    return this.getDecodedToken()?.payload?.email;
  }

  getPerfilSelecionado() {
    const perfilSelecionado = localStorage.getItem('perfilSelecionado') || '';

    if (perfilSelecionado.length > 0) {
      return JSON.parse(perfilSelecionado);
    }

    return ''
  }

  getFamiliaSelecionada() {
    return Number(localStorage.getItem('familiaSelecionada')) || '';
  }

  getTipoPerfilSelecionado() {
    return Number(localStorage.getItem('tipoPerfilSelecionado')) || '';
  }

  getDecursoPrazoCache(){
    return sessionStorage.getItem('decursoPrazo');
  }

  setDecursoPrazo(valorDecursoPrazo:any) {
    return sessionStorage.setItem('decursoPrazo', valorDecursoPrazo);
  }

  limparEstadoOAuth() {
    // Limpar apenas dados que podem caus ar conflito OAuth
    localStorage.removeItem('isLoggedInClosed');
    // Não limpar token, user durante o login ativo
  }

  limparStorage() {
    const keysToKeep = [...PERSISTENT_STORE_KEYS, 'autenticando'];

    const clearStorage = (storage: Storage) => {
      const keys = [];
      for (let i = 0; i < storage.length; i++) {
        const key = storage.key(i);
        if (key && !keysToKeep.includes(key)) {
          keys.push(key);
        }
      }
      keys.forEach(key => storage.removeItem(key));
    }
    clearStorage(localStorage);
    clearStorage(sessionStorage);
  }
}

const auth = new Auth();

export default auth;

